import { render, staticRenderFns } from "./AbrirLista.vue?vue&type=template&id=3618373b&"
import script from "./AbrirLista.vue?vue&type=script&lang=js&"
export * from "./AbrirLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports